<template>
  <div>
    <el-popover
      popper-class="export-import-popover"
      placement="bottom"
      trigger="click"
      v-model="showPopover"
      v-if="!isEdittingVisible && currentPage === PAGES.patientmanager"
    >
      <div>
        <el-button @click="showPopover = false">
          <label for="file" v-if="!isEdittingVisible">
            <input ref="file" id="file" type="file" accept=".mwl" hidden @change="importFile" />
            {{ $t("langcfg.txtDataImportTitle") }}
          </label>
        </el-button>
        <el-button
          @click="
            $bus.$emit('show-export');
            showPopover = false;
          "
        >
          {{ $t("langcfg.txtDataExportTitle") }}
        </el-button>
      </div>
      <span
        slot="reference"
        class="iconfont icon-daorudaochu right margin-right"
        v-if="!isEdittingVisible"
        style="font-size: 45px"
      ></span>
    </el-popover>
    <el-dialog
      :visible.sync="visible"
      fullscreen
      :title="$t('langcfg.txtHandlePatientMerge')"
      custom-class="df fdc export-import-dialog"
      :style="{ height: `${dispH}px` }"
    >
      <el-table
        :border="false"
        max-height="850"
        :data="patients.filter((v) => v.merge !== undefined)"
      >
        <el-table-column align="center" :label="$t('langcfg.txtIsMerge')" width="300">
          <template slot-scope="{ row }">
            <el-radio-group v-model="row.merge">
              <el-radio :label="true">{{ $t("langcfg.txtMerge") }}</el-radio>
              <el-radio :label="false">{{ $t("langcfg.txtNotMerge") }}</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column align="center" label="PID" width="300">
          <template slot-scope="{ row }">
            <div v-if="row.merge">{{ row.pid }}</div>
            <el-input
              v-else
              :placeholder="$t('langcfg.txtInputNewPid')"
              v-model="row.newPid"
              @click.native.stop.prevent="handleClick(row)"
              @touchend.native.stop.prevent="handleClick(row)"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('langcfg.txtSystemPatient')">
          <el-table-column align="center" :label="$t('langcfg.txtName')" width="250">
            <template slot-scope="{ row }">{{
              `${row.origin.firstname} ${row.origin.lastname ? row.origin.lastname : ""}`
            }}</template>
          </el-table-column>
          <el-table-column align="center" :label="$t('langcfg.txtSex')" width="150">
            <template slot-scope="{ row }">{{ getSex(row.origin.sex) }}</template>
          </el-table-column>
          <el-table-column align="center" prop="birthday" :label="$t('langcfg.txtDateOfBirth')">
            <template slot-scope="{ row }">{{ row.origin.birthday }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" :label="$t('langcfg.txtImportPatient')">
          <el-table-column
            align="center"
            prop="firstname"
            :label="$t('langcfg.txtName')"
            width="250"
          >
            <template slot-scope="{ row }">{{
              `${row.firstname} ${row.lastname ? row.lastname : ""}`
            }}</template>
          </el-table-column>
          <el-table-column align="center" prop="sex" :label="$t('langcfg.txtSex')" width="150">
            <template slot-scope="{ row }">{{ getSex(row.sex) }}</template>
          </el-table-column>
          <el-table-column align="center" prop="birthday" :label="$t('langcfg.txtDateOfBirth')">
          </el-table-column>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t("langcfg.txtCancel") }}</el-button>
        <el-button type="primary" @click="handleMerge">{{ $t("langcfg.txtMerge") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { PAGES } from "../../shared/consts";
const fs = window.require("fs");
const AdmZip = window.require("adm-zip");
const { dirname } = window.require("path");
import { Size, Message } from "../../mixins";
import fileSys from "../../fileoprators/fileSystem";
import { reloadPatientDB } from "../../services/patient";
import { reloadRecords } from "../../services/record";
import { reloadMediafiles } from "../../services/media";
import { checkImport, checkPid } from "../../services/export";
import EVENTS from "../../bus";
import { v4 as uuid } from "uuid";
export default {
  mixins: [Message, Size],
  props: {
    currentPage: String,
    isEdittingVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      PAGES,
      showPopover: false,
      visible: false,
      patients: [],
      checkPatient: [],
      records: [],
      entries: null
    };
  },
  created() {
    console.log(this.dispH);
  },
  computed: {
    patientPidMap() {
      return Object.fromEntries(this.patients.map((v) => [v.pid, v]));
    },
    recordMap() {
      return Object.fromEntries(this.records.map((v) => [v._id, v]));
    }
  },
  methods: {
    handleClick(row) {
      this.$bus.$emit(EVENTS.spreadKeyBoard, row.newPid, (value) => (row.newPid = value));
    },
    getSex(sex) {
      switch (sex) {
        case "F":
          return this.$t("langcfg.txtFemale");
        case "M":
          return this.$t("langcfg.txtMale");
        case "O":
          return this.$t("langcfg.txtSexOther");
        case "U":
          return this.$t("langcfg.txtSexUnknown");
        default:
          return "";
      }
    },
    handleMerge() {
      if (
        this.patients
          .filter((v) => typeof v.merge !== "undefined")
          .some((v) => !v.merge && !v.newPid)
      ) {
        this.message(this.$t("langcfg.txtInputPatientPidTip"), "error");
        return;
      }
      let patients = [],
        records = [];
      this.patients.forEach(({ merge, newPid, origin: { pid, ...op } = {}, ...p }) => {
        let fr = this.records.filter((v) => v.patientid === p._id);
        if (typeof merge === "boolean") {
          let mergePatient = {
            ...(merge ? op : p),
            pid: merge ? pid : newPid
          };
          patients.push(mergePatient);
          records.push(...fr.map((v) => ({ ...v, patientid: merge ? op._id : p._id })));
        } else {
          patients.push(p);
          records.push(...fr);
        }
      });
      return this.handleData(
        patients.map((v) => JSON.stringify(v)).join("\n"),
        records.map((v) => JSON.stringify(v)).join("\n")
      );
    },
    importFile(e) {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      const file = e.target.files[0];
      const path = file.path;
      setTimeout(async () => {
        try {
          const zip = new AdmZip(fs.readFileSync(path));

          this.entries = zip.getEntries();

          const recordDBEntries = this.entries.find((v) => v.entryName.endsWith("record.db"));
          const patientDBEntries = this.entries.find((v) => v.entryName.endsWith("patient.db"));
          e.target.value = "";

          if (recordDBEntries) {
            this.records = recordDBEntries
              .getData()
              .toString()
              .split("\n")
              .map((v) => JSON.parse(v));
            await checkImport(this.records).then((res) =>
              res.forEach((v) => {
                if (this.recordMap[v._id] && this.recordMap[v._id].patientid === v.patientid) {
                  this.$set(this.recordMap[v._id], "same", true);
                } else {
                  let record = this.records.find((cv) => cv._id === v._id);
                  record._id = uuid();
                }
              })
            );
          }

          if (patientDBEntries) {
            this.patients = patientDBEntries
              .getData()
              .toString()
              .split("\n")
              .map((v) => JSON.parse(v));

            await checkPid(this.patients).then((res) =>
              res.forEach((v) => {
                this.$set(this.patientPidMap[v.pid], "merge", true);
                this.$set(this.patientPidMap[v.pid], "newPid", "");
                this.patientPidMap[v.pid].origin = v;
              })
            );

            if (this.patients.some((v) => v.merge !== undefined)) {
              this.visible = true;
              this.$bus.$emit(EVENTS.hideGlobalWatting);
              return;
            }
          }
          return this.handleData(
            this.patients.map((v) => JSON.stringify(v)).join("\n"),
            this.records.map((v) => JSON.stringify(v)).join("\n")
          );
        } catch (error) {
          console.error(error);
          this.message("导入失败", "error");
          this.$bus.$emit(EVENTS.hideGlobalWatting);
        }
      }, 300);
    },
    handleData(patients, records) {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
      this.$msgbox({
        message: this.records.some((v) => v.same)
          ? this.$t("langcfg.txtConfirmCheckImportData")
          : this.$t("langcfg.txtConfirmImportData"),
        confirmButtonText: this.$t("langcfg.txtOK"),
        cancelButtonText: this.$t("langcfg.txtCancel"),
        showCancelButton: true,
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = this.$t("langcfg.txtImporting");
            instance.showCancelButton = false;

            setTimeout(async () => {
              this.entries.forEach((entry) => {
                const entryName = entry.entryName;
                const targetPath = fileSys.combinePath(
                  fileSys.sysPath.server,
                  entryName.replace("temp/", "")
                );
                const dirName = dirname(targetPath);
                if (!fs.existsSync(dirName)) {
                  fs.mkdirSync(dirName, { recursive: true });
                }
                if (entryName.endsWith("record.db") || entryName.endsWith("patient.db")) {
                  if (fs.existsSync(targetPath)) {
                    fs.appendFileSync(
                      targetPath,
                      entryName.endsWith("record.db") ? records : patients
                    );
                  } else {
                    fs.writeFileSync(
                      targetPath,
                      entryName.endsWith("record.db") ? records : patients
                    );
                  }
                } else if (entryName.endsWith(".db") && fs.existsSync(targetPath)) {
                  fs.appendFileSync(targetPath, entry.getData());
                } else {
                  fs.writeFileSync(targetPath, entry.getData());
                }
              });
              done();
              instance.confirmButtonLoading = false;
              this.message(this.$t("langcfg.txtImportSuccessful"), "success");
              reloadPatientDB();
              reloadRecords();
              reloadMediafiles();
              this.$bus.$emit("refresh-patients");
              this.visible = false;
            }, 300);
          } else {
            done();
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-table {
  // border: 1px solid rgba(128, 128, 128, 0.1);
  font-size: 20px !important;
  &.el-table--group {
    border: 1px solid rgba(128, 128, 128, 0.1);
  }

  th {
    background: transparent !important;
    border-bottom: 1px solid rgba(128, 128, 128, 0.5) !important;
    border-right: 1px solid rgba(128, 128, 128, 0.5) !important;
    padding: 12px 0;
  }
  td {
    height: 60px;
    padding: 0;
    border-right: 1px solid rgba(128, 128, 128, 0.5) !important;
    border-bottom: 1px solid rgba(128, 128, 128, 0.5) !important;
  }
}

/deep/ .el-dialog {
  .el-dialog__body {
    flex: 1;
  }
}

/deep/ .el-input {
  .el-input__inner {
    font-size: 20px;
    height: 35px;
    width: 270px;
  }
}

/deep/ .el-radio-group {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-radio__label {
    font-size: 20px;
  }
  .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  .el-radio {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
}

.margin-right {
  margin-right: 50px;
}

.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 52px;
  min-width: 125px;
  font-size: 20px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/ImportOrExportDataButton.vue